import { render, staticRenderFns } from "./PrintSettingGeneral.vue?vue&type=template&id=0b70d52e&scoped=true&"
import script from "./PrintSettingGeneral.vue?vue&type=script&lang=js&"
export * from "./PrintSettingGeneral.vue?vue&type=script&lang=js&"
import style0 from "./PrintSettingGeneral.vue?vue&type=style&index=0&id=0b70d52e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b70d52e",
  null
  
)

export default component.exports